export const ORDER_SOURCE = Object.freeze({
    /* 购物车*/
    Cart: 1,
    /* 产品详情*/
    Detail: 2
})
